export default __webpack_public_path__ + "static/media/thumbnail.78049852.png";